module.exports = __webpack_public_path__ + "img/listening-feedback-dark.2a36957b.svg";